import { get } from 'lodash'
import { required, requiredPhone, email, phone } from 'utils/validation'
import isValuePrefix from 'utils/isValuePrefix'

const validate = values => {
  let errors = {}

  errors = {
    email: required(get(values, 'email')) || email(get(values, 'email')),
    phoneNumber: requiredPhone(get(values, 'phoneNumber')) ||
      phone(get(values, 'phoneNumber')),
    phoneType: {
      value: required(get(values, 'phoneType.value'))
    },
    emailAgain: required(get(values, 'emailAgain')),
    secondaryEmail: email(get(values, 'secondaryEmail'))
  }

  if (get(values, 'email') && get(values, 'emailAgain')) {
    if (get(values, 'email') !== get(values, 'emailAgain')) {
      errors = {
        ...errors,
        emailAgain: {
          text: "Emails don't match",
          intlKey: 'errors.emails_dont_match'
        }
      }
    }
  }

  if (get(values, 'secondaryEmail')) {
    errors.secondaryEmailAgain = required(get(values, 'secondaryEmailAgain'))

    if (get(values, 'secondaryEmail') === get(values, 'email')) {
      errors.secondaryEmail = {
        text: 'Secondary email must be different than the primary one.',
        intlKey: 'errors.emails_must_be_different'
      }
    }

    if (
      get(values, 'secondaryEmailAgain') &&
      get(values, 'secondaryEmail') !== get(values, 'secondaryEmailAgain')
    ) {
      errors = {
        ...errors,
        secondaryEmailAgain: {
          text: "Emails don't match",
          intlKey: 'errors.emails_dont_match'
        }
      }
    }
  }

  if (
    get(values, 'secondaryPhoneNumber') &&
    get(values, 'secondaryPhoneNumber') !== '+'
  ) {
    if (!isValuePrefix(values.secondaryPhoneNumber)) {
      errors.secondaryPhoneNumber = phone(get(values, 'secondaryPhoneNumber'))
      errors.secondaryPhoneType = {
        value: required(get(values, 'secondaryPhoneType.value'))
      }
    }
  }

  return errors
}

export default validate
